/* MAIN */
const is = (data) => {
    return !/[\u0100-\uffff]/.test(data);
};
/* EXPORT */
export default is;
